var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"edit"},[_c('ul',[(_vm.isUser)?_c('li',[_c('span',{on:{"click":_vm.deleteThis}},[_vm._v(_vm._s(_vm.$t('global.删除')))])]):_vm._e(),_vm._v(" "),_c('li',[_c('span',{on:{"click":_vm.reportThis}},[_vm._v(_vm._s(_vm.$t('global.举报')))])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c5dabe3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/EditOrReport.vue
// module id = null
// module chunks = 